// @flow
export type ScrapStepState = {};

export const initialState: ScrapStepState = {};



// WEBPACK FOOTER //
// ./src/modules/new-order/ScrapStep/duck.js